import './App.css';
import React, { useContext, useEffect } from 'react';
// import { sendAnalyticsEvent } from './Utilities/tokenUtility';
// import ChatLandingPage from './ChatLandingPage';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom";
import { AuthProvider, AuthContext } from './Utilities/AuthContext';

import { FrontendDataProvider } from './Utilities/FrontendDataContext';
import Profile from './Profile';
import SubscriptionResult from './SubscriptionResult';
import Admin from './Admin';
import { BackendDataProvider } from './Utilities/BackendDataContext';

function App() {


  useEffect(() => {
    const target = 'https://dealcompass.co';
    if (window.location.hostname !== 'dealcompass.co') {
      window.location.replace(target);
    }
  }, []);


  return (
    <AuthProvider>
      <BackendDataProvider>
      <FrontendDataProvider>
        <Router>
          <Routes>
            {/* <Route path="/" element={<WithAnalytics><ChatLandingPage /></WithAnalytics>} /> */}
            <Route path="/" element={<div></div>} />
            <Route path="/redirect" element={<Redirect />} />
            <Route path="/trelloRedirect" element={<TrelloRedirect />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/subscriptionComplete" element={<SubscriptionResult complete={true}/>} />
            <Route path="/subscriptionError" element={<SubscriptionResult complete={false} />} />
            <Route path="/crespi" element={<Admin />} />
            </Routes>
        </Router>
      </FrontendDataProvider>
      </BackendDataProvider>
    </AuthProvider>

  );
}

export default App;


// function WithAnalytics({ children }) {
//   const location = useLocation();

//   useEffect(() => {
//     if (location.pathname === '/') {
//       sendAnalyticsEvent('arrived_on_page');
//     }
//   }, [location.pathname]);

//   return children;
// }



const Redirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {setIsLoggedIn} = useContext(AuthContext);

  useEffect(() => {

    console.error('Redirecting with location:', location);

    const params = new URLSearchParams(location.search);
    const authCode = params.get('authCode');
    if (!authCode) {
      console.error('Missing authCode in query params.');
      return;
    }
    
    verifySession(authCode, navigate, setIsLoggedIn)

  }, [location, navigate, setIsLoggedIn]);

  return <div style={{padding: "20px"}}>One moment while we redirect you...</div>;
};



export const verifySession = async (authCode, navigate, setIsLoggedIn) => {
  try {
    await fetch(
      "https://functionappfordev.azurewebsites.net/api/verifySession?action=AUTH_CODE"
      , {
        method: "POST",
        headers: {
          "X-UserSessionID": authCode,
        }
      // credentials: "include", // <== required to send authToken
    });

    // const result = await response.json();
      // alert("Session is valid", JSON.stringify(result));
      setIsLoggedIn(true);
      localStorage.setItem('UserSessionID', authCode); // Store session ID for future use
      if (navigate) {
        navigate('/'); // Redirect to the home page
      } else{
        window.location.href = '/'; // Fallback for non-React Router environments
      }

  } catch (err) {
    console.error("Session verification error:", err);
    setIsLoggedIn(false);

    // throw err;
  }

}


export const revokeSession = async (setIsLoggedIn) => {

    

  try {
    await fetch(
      "https://functionappfordev.azurewebsites.net/api/verifySession?action=REVOKE_SESSION"
      , {
        method: "POST",
        headers: {
          "X-UserSessionID": localStorage.getItem('UserSessionID'),
        }
      // credentials: "include", // <== required to send authToken
    });

      setIsLoggedIn(false);
      localStorage.removeItem('UserSessionID'); // Remove session ID from storage

  } catch (err) {
    console.error("Session verification error:", err);
    // throw err;
  }

}




const TrelloRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Extract token and state from the URL fragment
        const fragment = window.location.hash.substring(1); // Remove the '#' character
        const params = new URLSearchParams(fragment);
        const token = params.get('token');
        const state = new URLSearchParams(window.location.search).get('state');

        console.log('Trello Redirect:', { token, state });

        if (token && state)  {
            // Send token and state to the backend
            fetch('https://functionappfordev.azurewebsites.net/api/trelloAuthHandler', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-UserSessionID': localStorage.getItem('UserSessionID') || ''
                },
                body: JSON.stringify({ token, state }),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log('Success:', data);
                    // Redirect to a success page or handle the response
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    if (isMobile) {
                        // close 
                        navigate('/')
                    } else {
                      window.close()
                      // navigate('/'); // Adjust the route as needed
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    // Handle error appropriately
                    const el = document.getElementById('trello-redirect-header');
                    if (el) {
                        el.innerText = "Error processing Trello redirect. Please try again.";
                    }
                    console.error('Error processing Trello redirect:', error);
                    // Redirect to an error page or handle the error
                    // navigate('/error'); // Adjust the route as needed
                });
        } else {
            console.error('Token or state is missing.');
            const el = document.getElementById('trello-redirect-header');
            if (el) {
                el.innerText = "Error: Your request may have expired. Please try again.";
            }
            // navigate('/error'); // Redirect to an error page
        }
    }, [navigate]);

    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h1 
            id="trello-redirect-header"
            style={{
                fontSize: "24px",
                color: "rgb(109,109,109)",
                fontFamily: "Arial, sans-serif",
            }}>Processing Trello Redirect...</h1>
        </div>
    );
};

